export default "__VITE_ASSET__BVrMGyDo__"